import { createStore, combineReducers, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import thunkMiddleware from 'redux-thunk'

import { uiReducer } from './ui/reducers'
import { adminReducer } from './admin/reducers'
import { authReducer } from './auth/reducers'
import { analyticsProjectReducer } from './analyticsProject/reducers'
import { analyticsUserReducer } from './analyticsUser/reducers'
import { liveDataReducer } from './liveData/reducers'
import { projectsReducer } from './projects/reducers'
import { slackOAuthReducer } from './slackOAuth/reducers'
import { discordReducer } from './discord/reducers'
import { publicApiReducer } from './publicApi/reducers'

const rootReducer = combineReducers({
  ui: uiReducer,
  admin: adminReducer,
  auth: authReducer,
  analyticsProject: analyticsProjectReducer,
  analyticsUser: analyticsUserReducer,
  liveData: liveDataReducer,
  projects: projectsReducer,
  slackOAuth: slackOAuthReducer,
  discord: discordReducer,
  publicApi: publicApiReducer,
})

export type ReduxAppState = ReturnType<typeof rootReducer>

export default function configureStore() {
  const middlewares = [thunkMiddleware]
  const middleWareEnhancer = applyMiddleware(...middlewares)
  return createStore(rootReducer, composeWithDevTools(middleWareEnhancer))
}
